/**
 * seyoul-ajax-cart.js — INP Optimized
 * Changes:
 *  - CSS moved to seyoul-ajax-cart.css (no runtime injection)
 *  - backdrop-filter removed (mobile GPU cost)
 *  - body.overflow wrapped in rAF
 *  - click delegation scoped, passive where possible
 *  - renderPage uses DocumentFragment
 *  - DOM queries cached
 */
(function () {
  'use strict';

  /* ─────────────────────────────────────────────
     1. Cache DOM references (avoid repeated queries)
  ───────────────────────────────────────────── */
  var backdrop, miniCart;

  /* ─────────────────────────────────────────────
     2. Inject HTML once (CSS now in separate file)
  ───────────────────────────────────────────── */
  function injectHTML() {
    backdrop = document.createElement('div');
    backdrop.id = 'seyoul-mini-cart-backdrop';
    document.body.appendChild(backdrop);

    miniCart = document.createElement('div');
    miniCart.id = 'seyoul-mini-cart';
    miniCart.setAttribute('role', 'dialog');
    miniCart.setAttribute('aria-label', 'ตะกร้าสินค้า');
    miniCart.innerHTML = `
      <div class="seyoul-mc__header">
        <div class="seyoul-mc__header-left">
          <p class="seyoul-mc__header-label">Seyoul</p>
          <p class="seyoul-mc__header-title" id="seyoul-mc-title">ตะกร้าสินค้า</p>
        </div>
        <button class="seyoul-mc__close" id="seyoul-mc-close" aria-label="ปิด">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
            <path d="M18 6L6 18M6 6l12 12"/>
          </svg>
        </button>
      </div>
      <div class="seyoul-mc__subcount" id="seyoul-mc-subcount" style="display:none"></div>
      <div class="seyoul-mc__divider"></div>
      <div class="seyoul-mc__body" id="seyoul-mc-body">
        <div class="seyoul-mc__loading">
          <div class="seyoul-mc__spinner"></div>
          <span>กำลังโหลด...</span>
        </div>
      </div>
      <div class="seyoul-mc__divider"></div>
      <div class="seyoul-mc__footer">
        <div class="seyoul-mc__total-row" id="seyoul-mc-total-row" style="display:none">
          <span class="seyoul-mc__total-label">ยอดรวม</span>
          <span class="seyoul-mc__total-price" id="seyoul-mc-total"></span>
        </div>
        <div class="seyoul-mc__actions">
          <a href="/checkout" class="seyoul-mc__btn seyoul-mc__btn--primary" id="seyoul-mc-checkout">ชำระเงิน</a>
          <button class="seyoul-mc__btn seyoul-mc__btn--secondary" id="seyoul-mc-view-cart">ดูตะกร้า</button>
          <button class="seyoul-mc__btn seyoul-mc__btn--ghost" id="seyoul-mc-keep">ช้อปต่อ</button>
        </div>
      </div>
    `;
    document.body.appendChild(miniCart);
  }

  /* ─────────────────────────────────────────────
     3. Core functions
  ───────────────────────────────────────────── */

  var seyoulHandling = false;

  /** Monkey-patch cart-drawer-component to block auto-open during our flow */
  function patchCartDrawer() {
    customElements.whenDefined('cart-drawer-component').then(function () {
      var cartDrawerEl = document.querySelector('cart-drawer-component');
      if (!cartDrawerEl) return;

      var originalShowDialog = cartDrawerEl.showDialog
        ? cartDrawerEl.showDialog.bind(cartDrawerEl)
        : null;

      cartDrawerEl.showDialog = function () {
        if (seyoulHandling) return;
        if (originalShowDialog) originalShowDialog();
      };

      var originalOpen = cartDrawerEl.open
        ? cartDrawerEl.open.bind(cartDrawerEl)
        : null;
      cartDrawerEl.open = function () {
        if (seyoulHandling) return;
        if (originalOpen) originalOpen();
      };
    });
  }

  /** Open mini cart — INP fix: body.overflow in rAF to avoid forced layout */
  function openMiniCart() {
    backdrop.style.display = 'block';
    requestAnimationFrame(function () {
      backdrop.classList.add('is-open');
      miniCart.classList.add('is-open');
      // Defer overflow change to avoid layout cost in interaction handler
      requestAnimationFrame(function () {
        document.body.style.overflow = 'hidden';
      });
    });
  }

  /** Close mini cart */
  function closeMiniCart() {
    miniCart.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () {
      backdrop.style.display = 'none';
    }, 350);
  }

  /** Open the theme's native cart drawer (full screen) */
  function openNativeCartDrawer() {
    closeMiniCart();
    setTimeout(function () {
      var drawerEl = document.querySelector('cart-drawer-component');
      if (drawerEl) {
        if (typeof drawerEl.open === 'function') { drawerEl.open(); return; }
        if (typeof drawerEl.showDialog === 'function') { drawerEl.showDialog(); return; }
      }
      var cartBtn = document.querySelector('cart-drawer-component button[on\\:click*="/open"], cart-drawer-component > button');
      if (cartBtn) { cartBtn.click(); return; }
      var cartIcon = document.querySelector('.header-actions__cart-icon, [data-testid="cart-icon"]');
      if (cartIcon) { cartIcon.click(); return; }
      // Campaign layout has no Horizon cart-drawer-component → go to the cart page.
      window.location.href = '/cart';
    }, 380);
  }

  /** Fetch cart and render items in mini cart body */
  var mcCurrentPage = 0;
  var mcAllItems = [];
  var MC_PER_PAGE = 4;

  /** INP fix: build items via DocumentFragment instead of innerHTML string concat */
  function renderPage(page) {
    var body = document.getElementById('seyoul-mc-body');
    if (!body || !mcAllItems.length) return;

    var total = Math.ceil(mcAllItems.length / MC_PER_PAGE);
    mcCurrentPage = Math.max(0, Math.min(page, total - 1));
    var start = mcCurrentPage * MC_PER_PAGE;
    var pageItems = mcAllItems.slice(start, start + MC_PER_PAGE);

    // Build fragment off-DOM (no layout cost until append)
    var fragment = document.createDocumentFragment();

    var itemsDiv = document.createElement('div');
    itemsDiv.className = 'seyoul-mc__items';

    pageItems.forEach(function (item) {
      var imgSrc = item.image
        ? item.image.replace(/(\.(?:jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_400x400$1$2')
        : '';

      var lineTotal = (item.final_price * item.quantity / 100).toLocaleString('th-TH', {
        style: 'currency', currency: 'THB', minimumFractionDigits: 0
      });

      var compareHtml = '';
      if (item.original_price && item.original_price > item.final_price) {
        var origTotal = (item.original_price * item.quantity / 100).toLocaleString('th-TH', {
          style: 'currency', currency: 'THB', minimumFractionDigits: 0
        });
        compareHtml = origTotal;
      }

      // Build item DOM nodes
      var card = document.createElement('div');
      card.className = 'seyoul-mc__item';

      var imgWrap = document.createElement('div');
      imgWrap.className = 'seyoul-mc__item-img-wrap';
      if (imgSrc) {
        var img = document.createElement('img');
        img.src = imgSrc;
        img.alt = item.product_title;
        img.className = 'seyoul-mc__item-img';
        img.loading = 'lazy';
        img.decoding = 'async';
        imgWrap.appendChild(img);
      }

      var info = document.createElement('div');
      info.className = 'seyoul-mc__item-info';

      var name = document.createElement('p');
      name.className = 'seyoul-mc__item-name';
      name.textContent = item.product_title;

      var priceRow = document.createElement('div');
      priceRow.className = 'seyoul-mc__item-price-row';

      var priceSpan = document.createElement('span');
      priceSpan.className = 'seyoul-mc__item-price';
      priceSpan.textContent = lineTotal;
      priceRow.appendChild(priceSpan);

      if (compareHtml) {
        var compareSpan = document.createElement('span');
        compareSpan.className = 'seyoul-mc__item-compare';
        compareSpan.textContent = compareHtml;
        priceRow.appendChild(compareSpan);
      }

      var qtyBadge = document.createElement('p');
      qtyBadge.className = 'seyoul-mc__item-qty-badge';
      qtyBadge.textContent = 'x' + item.quantity;

      info.appendChild(name);
      info.appendChild(priceRow);
      info.appendChild(qtyBadge);

      card.appendChild(imgWrap);
      card.appendChild(info);
      itemsDiv.appendChild(card);
    });

    fragment.appendChild(itemsDiv);

    // Pagination
    if (total > 1) {
      var pag = document.createElement('div');
      pag.className = 'seyoul-mc__pagination';

      var prevBtn = document.createElement('button');
      prevBtn.className = 'seyoul-mc__page-btn';
      prevBtn.id = 'seyoul-mc-prev';
      if (mcCurrentPage === 0) prevBtn.disabled = true;
      prevBtn.innerHTML = '<svg width="8" height="12" viewBox="0 0 8 12" fill="none"><path d="M7 1L1 6L7 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

      var info2 = document.createElement('span');
      info2.className = 'seyoul-mc__page-info';
      info2.textContent = (mcCurrentPage + 1) + ' / ' + total;

      var nextBtn = document.createElement('button');
      nextBtn.className = 'seyoul-mc__page-btn';
      nextBtn.id = 'seyoul-mc-next';
      if (mcCurrentPage >= total - 1) nextBtn.disabled = true;
      nextBtn.innerHTML = '<svg width="8" height="12" viewBox="0 0 8 12" fill="none"><path d="M1 1L7 6L1 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

      pag.appendChild(prevBtn);
      pag.appendChild(info2);
      pag.appendChild(nextBtn);
      fragment.appendChild(pag);

      prevBtn.addEventListener('click', function() { renderPage(mcCurrentPage - 1); });
      nextBtn.addEventListener('click', function() { renderPage(mcCurrentPage + 1); });
    }

    // Single DOM write — minimise layout recalculation
    body.textContent = '';
    body.appendChild(fragment);
  }

  // Cache footer elements
  var _totalRow, _totalEl, _titleEl, _subcountEl, _bodyEl;
  function getCachedEls() {
    if (!_bodyEl) _bodyEl = document.getElementById('seyoul-mc-body');
    if (!_titleEl) _titleEl = document.getElementById('seyoul-mc-title');
    if (!_totalRow) _totalRow = document.getElementById('seyoul-mc-total-row');
    if (!_totalEl) _totalEl = document.getElementById('seyoul-mc-total');
    if (!_subcountEl) _subcountEl = document.getElementById('seyoul-mc-subcount');
  }

  function renderCartItems() {
    getCachedEls();

    // Show spinner
    _bodyEl.innerHTML = '<div class="seyoul-mc__loading"><div class="seyoul-mc__spinner"></div><span>กำลังโหลด...</span></div>';
    if (_totalRow) _totalRow.style.display = 'none';

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var count = cart.item_count || 0;
        var total = cart.total_price || 0;
        document.dispatchEvent(new CustomEvent('seyoul:cart-updated', {
          detail: { cart: cart }
        }));

        if (_titleEl) _titleEl.textContent = 'ตะกร้าสินค้า (' + count + ' ชิ้น)';

        if (_subcountEl) {
          _subcountEl.textContent = 'ทั้งหมด ' + count + ' รายการ';
          var isDesktop = window.innerWidth >= 750;
          _subcountEl.style.display = (count > 0 && isDesktop) ? 'block' : 'none';
        }

        if (_totalRow && _totalEl && count > 0) {
          _totalEl.textContent = (total / 100).toLocaleString('th-TH', {
            style: 'currency', currency: 'THB', minimumFractionDigits: 0
          });
          _totalRow.style.display = 'flex';
        }

        if (items.length === 0) {
          _bodyEl.innerHTML = '<div class="seyoul-mc__empty"><div class="seyoul-mc__empty-icon">🛍</div><p class="seyoul-mc__empty-text">ยังไม่มีสินค้าในตะกร้า</p></div>';
          return;
        }

        mcAllItems = items;
        mcCurrentPage = 0;
        renderPage(0);
        updateCartBubble(count);
      })
      .catch(function (err) {
        console.error('[Seyoul Mini Cart] Fetch error:', err);
        _bodyEl.innerHTML = '<div class="seyoul-mc__empty"><p class="seyoul-mc__empty-text">เกิดข้อผิดพลาด กรุณาลองใหม่</p></div>';
      });
  }

  /** Update all cart bubble elements in the header */
  function updateCartBubble(count) {
    document.querySelectorAll('[ref="cartBubbleCount"], .cart-bubble__text-count').forEach(function (el) {
      el.textContent = count > 0 ? (count < 100 ? String(count) : '') : '';
      el.classList.toggle('hidden', count === 0);
    });
    document.querySelectorAll('[ref="cartBubble"], .cart-bubble').forEach(function (el) {
      el.classList.toggle('visually-hidden', count === 0);
      if (count > 0) {
        el.classList.add('cart-bubble--animating');
        setTimeout(function () { el.classList.remove('cart-bubble--animating'); }, 600);
      }
    });
    document.querySelectorAll('cart-icon, .header-actions__cart-icon').forEach(function (el) {
      el.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
    });
    sessionStorage.setItem('cart-count', JSON.stringify({
      value: String(count),
      timestamp: Date.now()
    }));
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ─────────────────────────────────────────────
     4. AJAX Add to Cart
  ───────────────────────────────────────────── */
  function handleAddToCart(form, btn) {
    var variantId = form.querySelector('[name="id"]') && form.querySelector('[name="id"]').value;
    if (!variantId) return;
    var qtyInput = form.querySelector('[name="quantity"]');
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (!quantity || quantity < 1) quantity = 1;

    var origText = btn.textContent;
    btn.disabled = true;
    btn.textContent = '...';

    seyoulHandling = true;

    var cartDrawerEl = document.querySelector('cart-drawer-component');
    var hadAutoOpen = cartDrawerEl && cartDrawerEl.hasAttribute('auto-open');
    if (hadAutoOpen) cartDrawerEl.removeAttribute('auto-open');

    var blockCartUpdate = function (e) { e.stopImmediatePropagation(); };
    document.addEventListener('cart:update', blockCartUpdate, true);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: quantity })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function () {
        openMiniCart();
        renderCartItems();
      })
      .catch(function (err) {
        console.error('[Seyoul ATC] Error:', err);
        alert('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      })
      .finally(function () {
        btn.disabled = false;
        btn.textContent = origText;
        setTimeout(function () {
          seyoulHandling = false;
          if (hadAutoOpen && cartDrawerEl) cartDrawerEl.setAttribute('auto-open', '');
          document.removeEventListener('cart:update', blockCartUpdate, true);
        }, 1000);
      });
  }

  /* ─────────────────────────────────────────────
     5. Event Bindings
  ───────────────────────────────────────────── */
  function bindEvents() {
    document.getElementById('seyoul-mc-close').addEventListener('click', closeMiniCart);
    backdrop.addEventListener('click', closeMiniCart);
    document.getElementById('seyoul-mc-keep').addEventListener('click', closeMiniCart);
    document.getElementById('seyoul-mc-view-cart').addEventListener('click', openNativeCartDrawer);

    var SEYOUL_FORMS = [
      '.seyoul-pcarousel__form',
      '.seyoul-sets__info form',
      '.seyoul-qv-form',
      '.seyoul-flash-form',
    ].join(', ');

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches(SEYOUL_FORMS)) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var btn = form.querySelector('button[type="submit"]');
      if (btn) handleAddToCart(form, btn);
    }, true);

    // INP fix: only intercept our specific buttons, not every click on the page
    var SEYOUL_BTN_SELECTOR = '.seyoul-pcarousel__form button[type="submit"], .seyoul-sets__info form button[type="submit"], .seyoul-qv-form button[type="submit"], .seyoul-flash-form button[type="submit"]';

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest(SEYOUL_BTN_SELECTOR) : null;
      if (!btn) return;
      seyoulHandling = true;
      setTimeout(function () {
        if (!btn.disabled) seyoulHandling = false;
      }, 200);
    }, true);

    // ESC key — passive compatible
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMiniCart();
    });
  }

  /* ─────────────────────────────────────────────
     6. Init — defer non-critical work
  ───────────────────────────────────────────── */
  function init() {
    injectHTML();
    patchCartDrawer();
    bindEvents();
  }

  // Run after DOM is ready (script has defer, but guard anyway)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
